document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-dropdown-select-trigger]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      e.preventDefault();
    });
  });

  // Close any open dropdown if clicking outside of [data-dropdown-select]
  document.addEventListener(
    'click',
    (e) => {
      const openDropdowns = document.querySelectorAll(
        '.dropdown-select__content[aria-hidden="false"]'
      );
      if (openDropdowns.length === 0) return;

      // Check if click is inside any dropdown-select element
      const clickedInsideDropdown = e.target.closest('[data-dropdown-select]');
      if (!clickedInsideDropdown) {
        openDropdowns.forEach((dropdown) => {
          dropdown.setAttribute('aria-hidden', 'true');
          const triggerId = dropdown.id;
          document
            .querySelectorAll(`[aria-controls="${triggerId}"]`)
            .forEach((el) => {
              el.setAttribute('aria-expanded', 'false');
            });
        });
      }
    },
    true
  );

  // Handle click on dropdown item
  document
    .querySelectorAll('[data-dropdown-select-content]')
    .forEach((content) => {
      content.addEventListener('click', (e) => {
        // Allow normal behavior for links
        if (e.target.closest('a')) {
          e.stopPropagation();
          return;
        }

        const item = e.target.closest('[data-dropdown-select-item]');
        if (!item) return;

        // Locate the dropdown root
        const dropdown = item.closest('[data-dropdown-select]');
        if (!dropdown) return;

        // Value and text fields
        const valueField = dropdown.querySelector(
          '[data-dropdown-select-value]'
        );
        const textDisplay = dropdown.querySelector(
          '[data-dropdown-select-text]'
        );

        // Get values from button
        const value = item.getAttribute('data-dropdown-select-item-value');
        const text = item.getAttribute('data-dropdown-select-item-text');

        // Set hidden field value
        if (valueField && value !== null) {
          valueField.value = value;
          valueField.dispatchEvent(new Event('change'));
        }

        // Set visible trigger text
        if (textDisplay && text !== null) {
          textDisplay.textContent = text;
        }

        // Close dropdown
        const contentElem = dropdown.querySelector(
          '[data-dropdown-select-content]'
        );
        if (contentElem) {
          contentElem.setAttribute('aria-hidden', 'true');
        }
        // Update trigger aria-expanded
        dropdown
          .querySelectorAll('[data-dropdown-select-trigger]')
          .forEach((trigger) => {
            trigger.setAttribute('aria-expanded', 'false');
          });

        e.preventDefault();
        e.stopPropagation();
      });
    });
});
